import { HeaderIconRotatingCogs } from 'components/Icons'

import { Overlay } from './Overlay'

export const LoadingScreen = () => (
	<Overlay>
		<HeaderIconRotatingCogs size={362} />
	</Overlay>
)
